export const MAIN_CATEGORIES_ONE_WORD = ['Diseno', 'Programacion'];
export const MAIN_CATEGORIES = ['Diseño y Multimedia', 'Programación y Tecnología'];
